import Vue from "vue";
import VueRouter from "vue-router";
import { appPath } from "@/services";
import YearEndDistributions from "@/yearEndDistributions/YearEndDistributions.vue";
import QualifiedDividendIncome from "@/qualifiedDividendIncome/QualifiedDividendIncome.vue";
import ErrorPage from "@/error/ErrorPage.vue";
import { adobeLaunch } from "vg-fas-adobe-launch";
import store from "@/store";
import { log } from "@/services";
import { EventBus } from "@vg-faset/core";

Vue.use(VueRouter);

function fetchContentFromStore(routeName, next, routeData) {
	store.dispatch("fetchContent", routeName).then((result) => {
		if (result.error) {
			log(`There was an error getting content for route: ${routeName}. Redirecting to the Unavailable page.`);
			next({ path: "/unavailable" });
		} else {
			adobeLaunch.trackEvent("spaView", "spaView", routeData);
			EventBus.$emit("stickyfooter:reset");
			next();
		}
	});
}

const routes = [
	{
		path: "/year-end-distributions",
		name: "YearEndDistributions",
		component: YearEndDistributions,
		meta: {
			pageTitle: "Year end Vanguard funds distributions"
		},
		beforeEnter: (to, from, next) => {
			let routeData = {
				page: "yearEndDistributions"
			};

			fetchContentFromStore(to.name, next, routeData);
		}
	},
	{
		path: "/qualified-dividend-income",
		name: "QualifiedDividendIncome",
		component: QualifiedDividendIncome,
		meta: {
			pageTitle: "Qualified dividend income"
		},
		beforeEnter: (to, from, next) => {
			let routeData = {
				page: "qualifiedDividendIncome"
			};

			fetchContentFromStore(to.name, next, routeData);
		}
	},
	{
		path: "/unavailable",
		name: "PageUnavailable",
		component: ErrorPage,
		meta: {
			pageTitle: "Page not found"
		}
	},
	{
		path: "/*",
		name: "Default",
		beforeEnter: (to, from, next) => {
			next({ path: "/unavailable" });
		}
	}
];

const router = new VueRouter({
	mode: "history",
	base: appPath(),
	routes
});

export default router;
